import { gql } from 'graphql-tag';
/* AppSync */
import appsyncclient from '../../api/AppSync';
import imagesTable from "../mock/images"
import actions from "../constant";
import { getImageRelateds } from '../../graphql/nonclinical/imageProfile';


const initialState = {
  tableData: [],
  tableLoading: true,
};

export const imagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_IMAGE_STATE:
      return { ...state, tableData: action.payload.tableData }

    case actions.GET_IMAGE_TABLE_LOADING_STATE:
      return { ...state, tableLoading: action.payload.tableLoading}

    default:
      return state
  }
};


/**
 * 将graphql的返回值进行重构的结果
 * @param {obj} d graphql的返回值
 * @returns 
 */
const getImagesTable = (d) => {
  return d
}

export const getImagesTableData = (params, callBack) => async (dispatch, getState) => {
  try{
    dispatch({ type: actions.GET_IMAGE_TABLE_LOADING_STATE, payload: {
      tableLoading: "pending"
    }})
    const result = await appsyncclient.query({
      query: gql(getImageRelateds()),
      variables: params,
      fetchPolicy: 'no-cache',
    });
    const data = result.data?.getImageRelateds
    if (data) {
      const imagesTable = getImagesTable(data)
      dispatch({ type: actions.GET_IMAGE_STATE, payload: {
        tableData: imagesTable} })
      dispatch({ type: actions.GET_IMAGE_TABLE_LOADING_STATE, payload: {
        tableLoading: result.data.length === 0 ? "none" : false
      }})
      callBack && callBack(data)
    }else{
      dispatch({ type: actions.GET_IMAGE_TABLE_LOADING_STATE, payload: {
        tableLoading:"none"
      }})
    }
  } catch(e){
    console.error(e)
    dispatch({ type: actions.GET_IMAGE_TABLE_LOADING_STATE, payload: {
      tableLoading: "error"
    }})
    // 即使出现错误之后，3s后也会将table现有状态显示出来
    setTimeout(() =>{
      dispatch({ type: actions.GET_IMAGE_TABLE_LOADING_STATE, payload: {
      tableLoading: false
      }})
    }, 3000)
  }
  
};

